import { useContext } from 'react';

import { MemoryContext } from './memory-context';

function useMemory() {
  return useContext(MemoryContext);
}

export { useMemory };